import React, { useState, memo, useEffect, Fragment } from "react";
import axios from 'axios';
import { useRecoilState } from "recoil";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { ConfirmInfo } from './parts/ConfirmInfo';
import { AbleCource } from './parts/AbleCource';
import { FormCource } from './form/FormCource';
import { FormClinic } from './form/FormClinic';
import { FormOption } from './form/FormOption';
import { FormrRequestDate } from './form/FormrRequestDate';
import { FormExamDate } from './form/FormExamDate';
import { FormrNote } from './form/FormrNote';
import { FormCalendar } from './form/FormCalendar';
import { SeikenClinicInfo } from './parts/SeikenClinicInfo';
import { PrevPageButton } from './parts/PrevPageButton';
import { SubmitButton } from './parts/SubmitButton';

import { confirmState } from '../../store/confirmState';
import { orderState } from '../../store/orderState';
import { userState } from '../../store/userState';
import { companyState } from '../../store/companyState';
import { simulationAmountState } from '../../store/simulationAmountState';

export const ProxyCheckupEdit = memo((props) => {
  const { cm, user, staff_user, page_title, cources, cource_clinics } = props;
  const [pageAction, setPageAction] = useState('edit');
  const [isDisabled, setIsDisabled] = useState(true);
  const [isConfirm, setIsConfirm] = useRecoilState(confirmState);
  const [orderData, setOrderData] = useRecoilState(orderState);
  const [userData, setUserData] = useRecoilState(userState);
  const [cmData, setCmData] = useRecoilState(companyState);
  const [simulationAmountData, setSimulationAmountData] = useRecoilState(simulationAmountState);

  const initialSimulationAmountData = {
    loading: false,
    cource_type: null,
    funding_price: '',
    calc_price: '',
    result_price: '',
    message: '',
  }

  // 初期設定データセット
  useEffect(() => {
    setUserData({user_id: user});
    setCmData({company_id: cm});
  }, []);

  // CourceCode[1..79][110..119] 医療機関選択・自己手配計算処理
  const getSimulationAmount = async (data) => {
    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    const res = await axios.get(`/api/v1/calculations`, data)
                .then(resp => {
                  console.log("get SimulationAmount success");
                  // console.log(resp.data);
                  setSimulationAmountData(resp.data.simulation_amount);
                })
                .catch(e => {
                  console.log("SimulationAmount error");
                  // console.log(e.response);
                });
    return res;
  }

  // CourceCode[120..149] 生研用計算処理
  const getSimulationAmountWithSeiken = async (data) => {
    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    const res = await axios.get(`/api/v1/seiken_calculations`, data)
                .then(resp => {
                  console.log("get Seiken SimulationAmount success");
                  // console.log(resp.data);
                  setSimulationAmountData(resp.data.simulation_amount);
                })
                .catch(e => {
                  console.log("Seiken SimulationAmount error");
                  // console.log(e.response);
                });
    return res;
  }

  // 確認画面から前のページに戻る
  const onChangePrevPage = () => {
    window.scrollTo(0, 0);
    setSimulationAmountData(initialSimulationAmountData);
    setIsConfirm(false);
  }

  // CourceCode[1..79][110..119] 確認画面
  const onClickConfirmWithCal = () => {
    window.scrollTo(0, 0);
    setIsConfirm(true);

    var data = { params: {
      cource_id: orderData.cource_id,
      clinic_id: orderData.requestclinic_id,
      options: orderData.options,
    }};
    getSimulationAmount(data);
  }

  // Cource[120..149] 生研用確認画面
  const onClickConfirmWithSeikenCal = () => {
    window.scrollTo(0, 0);
    setIsConfirm(true);

    var data = { params: {
      cource_id: orderData.cource_id,
      options: orderData.options,
    }};
    getSimulationAmountWithSeiken(data);
  }

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true,
      });
    } else {
      toast.error(message, {
        hideProgressBar: false,
      });
    }
  }

 // ClinicCource[1..79] 送信
  const onSubmitOrderUpdate = (e) => {
    setIsDisabled(false);
    var data = {
      proxy_checkup: {
        mtemployee_id: userData.user_id,
        staff_users_id: staff_user,
        status: 'order_changed',
        cource_id: orderData.cource_id,
        cource_code: orderData.cource_code,
        requestcource: orderData.requestcource,
        requestpref_code: orderData.requestpref_code,
        requestclinic_id: orderData.requestclinic_id,
        requestclinic: orderData.requestclinic,
        dtpendingorder_options_attributes: orderData.options,
        requestdt1: orderData.requestdt1,
        requestdt1_ampm: orderData.requestdt1_ampm,
        requestdt2: orderData.requestdt2,
        requestdt2_ampm: orderData.requestdt2_ampm,
        requestdt3: orderData.requestdt3,
        requestdt3_ampm: orderData.requestdt3_ampm,
        requestnote: orderData.requestnote,
        calc_price: simulationAmountData.calc_price,
        result_price: simulationAmountData.result_price,
      },
      mtemployee_id: userData.user_id,
    };

    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.put(`/agent/proxy_checkup`, data)
    .then(resp => {
      console.log("ProxyOrder Update api ok");
      console.log(resp.data);
      notify("success", "ProxyOrder Update Success!");
      window.location.href = `/agent/proxy_checkup?mtemployee_id=${userData.user_id}`;
    })
    .catch(e => {
      console.log("ProxyOrder Update api ng");
      console.log(e.response);
      window.scrollTo(0, 0);
      setIsConfirm(!isConfirm);
      alert(JSON.parse(e.request.responseText).errors);
      notify("error", "ProxyOrder Update Error!");
      setIsDisabled(true);
    });
  }

  // JigoCource[110..119] 送信
  const onSubmitJigoOrderUpdate = (e) => {
    setIsDisabled(false);
    var data = { 
      proxy_checkup: {
        mtemployee_id: userData.user_id,
        staff_users_id: staff_user,
        status: 'order_commited',
        cource_id: orderData.cource_id,
        cource_code: orderData.cource_code,
        requestcource: orderData.requestcource,
        requestpref_code: orderData.requestpref_code,
        requestclinic_id: orderData.requestclinic_id,
        requestclinic: orderData.requestclinic,
        dtpendingorder_options_attributes: orderData.options,
        examclinic_id: orderData.requestclinic_id,
        examclinic: orderData.requestclinic,
        examdt: `${orderData.examdt} ${orderData.examdtime}`,
        requestnote: orderData.requestnote,
        calc_price: simulationAmountData.calc_price,
        result_price: simulationAmountData.result_price,
      },
      mtemployee_id: userData.user_id,
    };

    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.put(`/agent/proxy_checkup`, data)
    .then(resp => {
      console.log("Proxy JigoCource api ok");
      console.log(resp.data);
      notify("success", "Proxy JigoCource Update Success!");
      window.location.href = `/agent/proxy_checkup?mtemployee_id=${userData.user_id}`;
    })
    .catch(e => {
      console.log("Proxy JigoCource api ng");
      console.log(e.response);
      window.scrollTo(0, 0);
      setIsConfirm(!isConfirm);
      alert(JSON.parse(e.request.responseText).errors);
      notify("error", "Proxy JigoCource Update Error!");
      setIsDisabled(true);
    });
  }

  // SeikenForm(CourceItem) [120..149] 送信
  const onSubmitSeikenOrderUpdate = (e) => {
    setIsDisabled(false);
    var data = { 
      proxy_checkup: {
        mtemployee_id: userData.user_id,
        staff_users_id: staff_user,
        status: 'order_commited',
        cource_id: orderData.cource_id,
        cource_code: orderData.cource_code,
        requestcource: orderData.requestcource,
        examclinic: '朝日生命成人病研究所附属医院',
        examdt: orderData.examdt,
        item_id: orderData.item_id,
        calc_price: simulationAmountData.calc_price,
        result_price: simulationAmountData.result_price,
      },
      mtemployee_id: userData.user_id,
    };

    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.put(`/agent/proxy_checkup`, data)
    .then(resp => {
      console.log("Proxy CourceItem api ok");
      console.log(resp.data);
      notify("success", "Proxy CourceItem Update Success!");
      window.location.href = `/agent/proxy_checkup?mtemployee_id=${userData.user_id}`;
    })
    .catch(e => {
      console.log("Proxy CourceItem api ng");
      console.log(e.response);
      window.scrollTo(0, 0);
      setIsConfirm(!isConfirm);
      alert(JSON.parse(e.request.responseText).errors);
      notify("error", "Proxy CourceItem Update Error!");
      setIsDisabled(true);
    });
  }

  const SwitchFormDisplay = () => {
    if (110 <= parseInt(orderData.cource_code, 10) && parseInt(orderData.cource_code, 10) < 119) {
      // JigoCourceForm [110..119]
      return (
        <Fragment>
          <FormCource cources={cources} />
          <FormClinic
            pageAction={pageAction}
            cource_clinics={cource_clinics}
          />
          <FormOption />
          <FormExamDate />
          <FormrNote />
          { isConfirm ?
            <Fragment>
              <PrevPageButton text="内容の修正" onClick={onChangePrevPage} />
              <SubmitButton
                text="[編集]自己手配報告する"
                onClick={onSubmitJigoOrderUpdate}
                isDisabledVal={
                  isDisabled
                  && simulationAmountData.loading
                  && orderData.cource_id
                  && orderData.cource_code
                  && orderData.requestcource
                  && orderData.requestpref_code
                  && orderData.requestclinic_id
                  && orderData.requestclinic
                  && orderData.examdt
                  && orderData.examdtime ? false : true
                }
              />
            </Fragment>
          :
            <SubmitButton 
              text="[編集]自己手配報告の確認画面へ"
              onClick={onClickConfirmWithCal}
              isDisabledVal={
                isDisabled
                && orderData.cource_id
                && orderData.cource_code
                && orderData.requestcource
                && orderData.requestpref_code
                && orderData.requestclinic_id
                && orderData.requestclinic
                && orderData.examdt
                && orderData.examdtime ? false : true
              }
            />
          }
        </Fragment>
      )
    } else if (120 <= parseInt(orderData.cource_code, 10) && parseInt(orderData.cource_code, 10) < 149) {
      // SeikenForm(CourceItem) [120..149]
      return (
        <Fragment>
          <FormCource cources={cources} />
          <SeikenClinicInfo />
          <FormCalendar />
          { isConfirm ?
            <Fragment>
              <PrevPageButton text="内容の修正" onClick={onChangePrevPage} />
              <SubmitButton
                text="[編集]生研の予約申し込み"
                onClick={onSubmitSeikenOrderUpdate}
                isDisabledVal={
                  isDisabled
                  && simulationAmountData.loading
                  && orderData.cource_id
                  && orderData.cource_code
                  && orderData.requestcource
                  && orderData.examdt
                  && orderData.item_id ? false : true
                }
              />
            </Fragment>
          :
            <SubmitButton 
              text="[編集]生研の確認画面へ"
              onClick={onClickConfirmWithSeikenCal}
              isDisabledVal={
                isDisabled
                && orderData.cource_id
                && orderData.cource_code
                && orderData.requestcource
                && orderData.examdt
                && orderData.item_id ? false : true
              }
            />
          }
        </Fragment>
      )
    } else {
      // DefaultForm [1..79]
      return (
        <Fragment>
          <FormCource cources={cources} />
          <FormClinic
            pageAction={pageAction}
            cource_clinics={cource_clinics}
          />
          <FormOption />
          <FormrRequestDate />
          <FormrNote />
          { isConfirm ?
            <Fragment>
              <button type="submit" name="testName" value="testValue" className="btn btn-outline-secondary btn-lg w-100 mb-3" onClick={onChangePrevPage}><i className="fas fa-chevron-left"></i> 内容の修正</button>
              <SubmitButton 
              text="[編集]予約申し込み"
              onClick={onSubmitOrderUpdate}
              isDisabledVal={
                isDisabled
                && simulationAmountData.loading
                && orderData.cource_id
                && orderData.cource_code
                && orderData.requestcource
                && orderData.requestpref_code
                && orderData.requestclinic_id
                && orderData.requestclinic
                && orderData.requestdt1
                && orderData.requestdt2
                && orderData.requestdt3 ? false : true
              }
            />
            </Fragment>
          :
            <SubmitButton 
              text="[編集]予約確認画面へ"
              onClick={onClickConfirmWithCal}
              isDisabledVal={
                isDisabled
                && orderData.cource_id
                && orderData.cource_code
                && orderData.requestcource
                && orderData.requestpref_code
                && orderData.requestclinic_id
                && orderData.requestclinic
                && orderData.requestdt1
                && orderData.requestdt2
                && orderData.requestdt3 ? false : true
              }
            />
          }
        </Fragment>
      )
    }
  }

  console.log("Proxy Edit");
  return (
    <>
      <ToastContainer />
      <h1 id="top">{page_title}{isConfirm && "（内容確認）"}</h1>
      { isConfirm && <ConfirmInfo /> }
      { SwitchFormDisplay() }
    </>
  );
});